import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {DetailCategoryDataService} from './detail-category-data.service';
import {HintDialogService} from '../../../../../../../dialogs/hint';
import {NGXLogger} from 'ngx-logger';
import {Exception} from '../../../../../../core/models';
import {DetailCategoryActions} from './detail-category.actions';
import {AppActions} from '../../../app-store/src/+state/app.actions';


@Injectable()
export class DetailCategoryEffects {

  loadCategoriesRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DetailCategoryActions.loadCategoriesRequest),

      switchMap(action => this.detailCategoryDataService.load().pipe(
        map(payload => DetailCategoryActions.loadCategoriesSuccess({payload})),
        catchError(error => of(DetailCategoryActions.loadCategoriesFailure({exception: new Exception(error, action)})))
      )),
    )
  );

  loadCategoriesSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DetailCategoryActions.loadCategoriesSuccess),
    ), {dispatch: false}
  );

  loadCategoriesFailure$ = createEffect(
    () => this.actions$.pipe(
      ofType(DetailCategoryActions.loadCategoriesFailure),

      map(action => action.exception),
      map(exception => AppActions.showFailureMessage({exception})),
    )
  );


  constructor(private actions$: Actions, private detailCategoryDataService: DetailCategoryDataService,
              private hintDialogService: HintDialogService, private logger: NGXLogger) {

  }

}
